<template>
  <div>
    <ValidationObserver v-slot="{ invalid }">
      <b-modal id="MaterialLoss" size="lg" no-close-on-backdrop ok-title="Zapisz" cancel-title="Zamknij"
        :title="'Zgłoszenie straty materiału / surowca: ' + itemName">
        <validation-provider rules="required|min_value:0" v-slot="{ errors }">
          <label for="weight" class="form-label">Waga straty w kg</label>
          <input type="number" class="form-control" step="0.001" v-model="weight"
            placeholder="Podaj wagę straconego materiału / surowca" />
          <b-alert class="mt-2" v-show="errors[0] !== undefined" show variant="danger">{{ errors[0] }}</b-alert>
        </validation-provider>

        <template #modal-footer>
          <b-button @click="CloseModal()">
            Anuluj
          </b-button>
          <b-button :disabled="invalid" variant="primary" @click="SubmitForm()">
            Zapisz
          </b-button>
        </template>
      </b-modal>
    </ValidationObserver>

  </div>
</template>

<script>
import toastr from "../../mixins/toastr";
import deliveryMixin from '../../mixins/delivery'
import { ValidationObserver } from 'vee-validate';


export default {
  name: "MaterialLoss",
  mixins: [toastr, deliveryMixin],
  components: { ValidationObserver },
  data() {
    return {
      itemId: 0,
      itemName: "",
      weight: 0,
      typeOfLoss: "",
    };
  },
  methods: {
    SubmitForm() {
      var that = this;

      console.log("Submit Form Material Lose", this.typeOfLoss, this.itemId, this.weight)
      this.registerMaterialLoss(this.typeOfLoss, this.itemId, this.weight)
        .then((res) => {
          if (res.data.success) {
            that.DisplaySuccess("Sukces!", "Strata materiału została zapisana");
            that.$bvModal.hide("MaterialLoss");
          } else {
            that.DisplayError("Błąd!", res.data.errors[0]);
          }
        }).catach(() => {
          that.DisplaySuccess(
            "Błąd!",
            "Nie udało się zapisać straty. Spróbuj ponowanie za chwilę."
          );
        });
    },
    CloseModal() {
      this.$bvModal.hide("MaterialLoss");

    },
    OpenModal() {
      this.weight = 0;
      this.$bvModal.show("MaterialLoss");
    }
  },
};
</script>
